import theMoment from 'moment'

function dayDiff (date1, date2) {
  let diffTime = Math.abs(date2.getTime() - date1.getTime())
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}

function cutTime (dt) {
  if (dt == null) return ''
  return dt.substring(0, 10)
}

function formatDateTime (dt) {
  if (dt == null) return null
  return dt.substring(0, 10) + ' 00:00:00'
}

function firstDayOfYear (dt) {
  let date = new Date(dt.getTime())
  date.setMonth(0)
  date.setDate(1)
  return date
}

function lastDayOfYear (dt) {
  let date = new Date(dt.getTime())
  date.setMonth(11)
  date.setDate(31)
  return date
}

function dateToYyyyMmDd (dt) {
  let dateStr = ''
  if (dt != null) {
    let monthPre = ''
    if (dt.getMonth() + 1 < 10) {
      monthPre = '0'
    }
    let datePre = ''
    if (dt.getDate() < 10) {
      datePre = '0'
    }
    dateStr = dt.getFullYear() + '-' + monthPre + (dt.getMonth() + 1) + '-' + datePre + dt.getDate()
  }
  return dateStr
}

function yyyyMmDdToDate (str) {
  return new Date(cutTime(str))
}

function timestampToYyyyMmDdHhMmSs (timestamp) {
  let datetime = timestampToDate(timestamp)
  let year = '' + datetime.getFullYear()
  let month = '' + (datetime.getMonth() + 1); if (month.length === 1) { month = '0' + month }
  let day = '' + datetime.getDate(); if (day.length === 1) { day = '0' + day }
  let hour = '' + datetime.getHours(); if (hour.length === 1) { hour = '0' + hour }
  let minute = '' + datetime.getMinutes(); if (minute.length === 1) { minute = '0' + minute }
  let second = '' + datetime.getSeconds(); if (second.length === 1) { second = '0' + second }
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
}

function longDateStrToYyyyMmDdHhMmSs (dateStr) {
  return dateStr.slice(0, 16)
}

function timestampToDate (timestamp) {
  if (timestamp.length > 10) {
    let tTimestamp = timestamp.slice(0, 10) + 'T' + timestamp.slice(11)
    return new Date(tTimestamp)
  } else {
    return new Date(timestamp)
  }
}

function dateStrToYyyyMmDdHhMm (str) {
  return str.substring(0, 16)
}

function dateStrToMmDdHhMm (str) {
  return str.substring(5, 16)
}

function dateStrToHhMm (str) {
  return str.substring(10, 16)
}

function dateStrToddmm (dateStr) {
  return getDay(dateStr) + '/' + getMonth(dateStr)
}

function dateToMonthString (dt, lang, style = 'long') {
  let intlFormatter = new Intl.DateTimeFormat(lang, { month: style })
  const monthString = intlFormatter.format(dt)
  return monthString.charAt(0).toUpperCase() + monthString.slice(1)
}

function isValidDate (year, month, day) {
  let date = new Date(year, month, day)
  if (date.getDate() === day) {
    return true
  } else {
    return false
  }
}

function isSatOrSun (date) {
  let dayOfWeek = date.getDay()
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    return true
  } else {
    return false
  }
}

function getDayOfWeekStr (date, lang, style) {
  let options = { weekday: style }
  let dayOfWeekStr = new Intl.DateTimeFormat(lang, options).format(date)
  if (lang === 'zh' && style === 'short') {
    dayOfWeekStr = dayOfWeekStr.slice(1)
  } else if (lang === 'pt') {
    dayOfWeekStr = dayOfWeekStr.charAt(0).toUpperCase() + dayOfWeekStr.slice(1)
  }
  return dayOfWeekStr
}

// Get the date "YYYY-mm-dd" of the week
// i: 0-6  (e.g. 0:Sunday; 1:Monday; ... 6:Saturday)
// date: Any date in the week
function getDateStrOfWeek (date, i) {
  let firstDay = new Date(date - (date.getDay()) * 86400000)
  firstDay.setDate(firstDay.getDate() + i)
  let mon = Number(firstDay.getMonth()) + 1
  return firstDay.getFullYear() + '-' + mon + '-' + firstDay.getDate()
}

function secondToHourMinute (seconds, style) {
  let numSeconds = ~~seconds
  let hours = parseInt(numSeconds / 60)
  let minutes = numSeconds % 60
  if (style === 'xh xm') {
    return hours + 'h ' + minutes + 'm'
  } else {
    let hh = hours < 10 ? '0' + hours : hours
    let mm = minutes < 10 ? '0' + minutes : minutes
    return hh + ':' + mm
  }
}

// change SSM's date format of yyyymmdd to yyyy-mm-dd
function formatSSMDate (dateStr) {
  return dateStr.slice(0, 4) + '-' + dateStr.slice(4, 6) + '-' + dateStr.slice(6, 8)
}

// return the yyyy part of the dateStr (yyyy-mm-dd)
function getYear (dateStr) {
  return dateStr.slice(0, 4)
}

// set the year part of the dateStr (yyyy-mm-dd)
function setYear (dateStr, year) {
  return year + dateStr.slice(4, 10)
}

// return the mm part of the dateStr (yyyy-mm-dd)
function getMonth (dateStr) {
  return dateStr.slice(5, 7)
}

// set the month part of the dateStr (yyyy-mm-dd)
function setMonth (dateStr, month) {
  if (month < 10) {
    month = '0' + month
  }
  return dateStr.slice(0, 5) + month + dateStr.slice(7, 10)
}

// return the dd part of the dateStr (yyyy-mm-dd)
function getDay (dateStr) {
  return dateStr.slice(8, 10)
}

// set the day part of the dateStr (yyyy-mm-dd)
function setDay (dateStr, day) {
  if (day < 10) {
    day = '0' + day
  }
  return dateStr.slice(0, 8) + day
}

// dateStr in yyyy-mm-dd format
function nextMonth (dateStr) {
  let date = new Date(getYear(dateStr), getMonth(dateStr), getDay(dateStr))
  return dateToYyyyMmDd(date)
}

// dateStr in yyyy-mm-dd format
function previousMonth (dateStr) {
  let date = new Date(getYear(dateStr), getMonth(dateStr) - 2, getDay(dateStr))
  return dateToYyyyMmDd(date)
}

function momentWithHyphen (val) {
  if (!val) return { format: () => { return '--' } } // hack original moment. if input value is null, it will return '--'
  return theMoment(val)
}

// export as object.function "e.g. datetimeUtil.dayDiff, datetimeUtil.cutTime"
export default { dayDiff, cutTime, formatDateTime, dateToYyyyMmDd, yyyyMmDdToDate, firstDayOfYear, lastDayOfYear, timestampToYyyyMmDdHhMmSs, dateStrToddmm, dateToMonthString, isValidDate, isSatOrSun, getDayOfWeekStr, getDateStrOfWeek, secondToHourMinute, formatSSMDate, dateStrToYyyyMmDdHhMm, dateStrToMmDdHhMm, longDateStrToYyyyMmDdHhMmSs, dateStrToHhMm, getYear, getMonth, getDay, setYear, setMonth, setDay, nextMonth, previousMonth, momentWithHyphen }

// export as dayDiff, cutTime, .......
export { dayDiff, cutTime, formatDateTime, dateToYyyyMmDd, yyyyMmDdToDate, firstDayOfYear, lastDayOfYear, timestampToYyyyMmDdHhMmSs, dateStrToddmm, dateToMonthString, isValidDate, isSatOrSun, getDayOfWeekStr, getDateStrOfWeek, secondToHourMinute, formatSSMDate, dateStrToYyyyMmDdHhMm, dateStrToMmDdHhMm, longDateStrToYyyyMmDdHhMmSs, dateStrToHhMm, getYear, getMonth, getDay, setYear, setMonth, setDay, nextMonth, previousMonth, momentWithHyphen }
